import React, { useEffect, useState } from "react";
import {
  Table,
  Input,
  message,
  Button,
  Space,
  Spin,
  Typography,
  notification,
  Card,
  Tooltip,
  Alert,
  Select,
  Row,
  Col,
  Statistic,
  Modal,
  Form,
} from "antd";
import {
  SearchOutlined,
  ClearOutlined,
  PlusOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { getAllparticipantesSostenibilidad } from "../../../services/sostenibilidad/participantesSostenibilidad";
import Header166 from "../../header/header";
import ParticipanteForm from "./FormParticipanteSostenibilidad";
import { useSelector } from "react-redux";
import { selectAppPermissions } from "../../../store/auth/selectors";

const { Title } = Typography;
const { Option } = Select;

const ParticipantesSostenibilidad = () => {
  const [listParticipantes, setListParticipantes] = useState([]);
  const [filterParticipantes, setFilterParticipantes] = useState([]);
  const [selectParticipante, setSelectParticipante] = useState(null);

  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [modalVisible, setModalVisible] = useState(false);
  const [modalKey, setModalKey] = useState(0);
  const [formParticipante] = Form.useForm();

  const [departamentoSeleccionado, setDepartamentoSeleccionado] =
    useState(null);
  const [municipioSeleccionado, setMunicipioSeleccionado] = useState(null);
  const [proyectoSeleccionado, setProyectoSeleccionado] = useState(null);

  const [listDepartamento, setListDepartamento] = useState([]);
  const [listMunicipio, setListMunicipio] = useState([]);

  const [listMunicipiosPorDepartamento, setListMunicipiosPorDepartamento] =
    useState([]);
  const [listProyectos, setListProyectos] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  //Control de Permisos
  const appName = "participantes-sostenibilidad";
  const permissions = useSelector((state) =>
    selectAppPermissions(state, appName)
  );
  const permissionDelete = permissions.priv_delete === "Y";
  const permissionUpdate = permissions.priv_update === "Y";
  const permissionInsert = permissions.priv_insert === "Y";

  const fetchparticipantes = async () => {
    try {
      const response = await getAllparticipantesSostenibilidad();
      const { status, participantes } = response;

      if (status) {
        setListParticipantes(participantes);
        setFilterParticipantes(participantes);

        const departamentos = [
          ...new Set(participantes.map((p) => p.departamento)),
        ];
        setListDepartamento(departamentos);
        // Agrupar municipios por departamento
        const municipiosPorDepartamento = participantes.reduce((acc, p) => {
          if (!acc[p.departamento]) {
            acc[p.departamento] = new Set();
          }
          acc[p.departamento].add(p.municipio);
          return acc;
        }, {});
        //Almacenamos la lista de municipios por departamento
        setListMunicipiosPorDepartamento(municipiosPorDepartamento);

        //Almacenar la lista de proyectos
        const proyectos = [...new Set(participantes.map((p) => p.sigla))];
        setListProyectos(proyectos);
      } else {
        notification.error({
          message: "Error",
          description: message || "Failed to fetch participantes data.",
        });
      }
    } catch (error) {
      notification.error({
        message: "Error",
        description: "No se han cargado los participantes de Sostenibilidad.",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchparticipantes();
  }, []);

  useEffect(() => {
    if (!listParticipantes) return;

    let visitasFiltradas = [...listParticipantes];

    if (departamentoSeleccionado) {
      visitasFiltradas = visitasFiltradas.filter(
        (p) => p.departamento === departamentoSeleccionado
      );

      // Lista de municipios filtrados por el departamento seleccionado
      const municipios = departamentoSeleccionado
        ? [...listMunicipiosPorDepartamento[departamentoSeleccionado]]
        : [];
      setListMunicipio(municipios);
    }

    if (municipioSeleccionado) {
      visitasFiltradas = visitasFiltradas.filter(
        (p) => p.municipio === municipioSeleccionado
      );
    }

    if (proyectoSeleccionado) {
      visitasFiltradas = visitasFiltradas.filter(
        (p) => p.sigla === proyectoSeleccionado
      );
    }

    if (searchText?.trim()) {
      // Verifica que no sea nulo, vacío o solo espacios
      visitasFiltradas = visitasFiltradas.filter((participant) =>
        Object.values(participant).some(
          (val) =>
            typeof val === "string" &&
            val.toLowerCase().includes(searchText.toLowerCase())
        )
      );
    }

    setFilterParticipantes(visitasFiltradas);
  }, [
    departamentoSeleccionado,
    municipioSeleccionado,
    proyectoSeleccionado,
    searchText,
  ]);
  const handleCancel = () => {
    Modal.confirm({
      title: "¿Está segur@ de que desea cerrar?",
      content:
        "Si cierra esta ventana, la información ingresada no se guardará.",
      okText: "Sí, cerrar",
      cancelText: "No",
      onOk: () => {
        setModalVisible(false);
        formParticipante.resetFields();
        setSelectParticipante(null);
      },
    });
  };

  const handleClearFilters = () => {
    // Limpiar el texto de búsqueda y municipio
    setSearchText("");
    setMunicipioSeleccionado(null);
    setDepartamentoSeleccionado(null);
    setProyectoSeleccionado(null);
    // Restablecer la lista filtrada a la lista original
    setFilterParticipantes(listParticipantes);
  };
  const columns = [
    {
      title: "Departamento",
      dataIndex: "departamento",
      key: "departamento",
      width: 150,
    },
    {
      title: "Municipio",
      dataIndex: "municipio",
      key: "municipio",
      width: 150,
    },
    {
      title: "Organización",
      dataIndex: "sigla",
      key: "sigla",
      width: 150,
    },
    {
      title: "Codigo PRE",
      dataIndex: "codigo_pre",
      key: "codigo_pre",
      width: 150,
    },
    {
      title: "Codigo SIRR",
      dataIndex: "codigo_sirr",
      key: "codigo_sirr",
      width: 150,
    },

    {
      title: "Nombres y apellidos",
      dataIndex: "nombre_completo",
      key: "nombre_completo",
      width: 150,
    },
    {
      title: "Genero",
      dataIndex: "genero",
      key: "genero",
      width: 150,
    },
    {
      title: "Edad",
      dataIndex: "edad",
      key: "edad",
      align: "center",
      width: 70,
    },

    {
      title: "Discapacidad",
      dataIndex: "tipo_discapacidad",
      key: "tipo_discapacidad",
      width: 130,
    },
    {
      title: "Enfoque étnico",
      dataIndex: "enfoque_etnico",
      key: "enfoque_etnico",
      width: 200,
      render: (text) => {
        if (!text) return null;
        const isLong = text.length > 50;
        return isLong ? (
          <Tooltip title={text}>
            <span>{text.slice(0, 50)}...</span>
          </Tooltip>
        ) : (
          text
        );
      },
    },

    {
      title: "Tipo participante",
      dataIndex: "tipo_participante",
      key: "tipo_participante",
      width: 130,
    },
    {
      title: "Firmante",
      dataIndex: "firmante",
      key: "firmante",
      width: 100,
      align: "center",
    },
  ];

  return (
    <>
      <>
        {/* Aquí va el resto del contenido que deseas mostrar cuando no se está creando una novedad */}
        {loading ? (
          <div className="text-center">
            <Spin size="large" />
          </div>
        ) : (
          <>
            <div className="container">
              <div style={{ padding: "20px" }}>
                <Header166 type="poaS" />
                <Row gutter={[16, 16]} className="mb-4">
                  <Col span={24}>
                    <div className="filter-container">
                      <Row gutter={[16, 16]} align="middle">
                        {/* Filtros */}
                        {/* Departamento */}
                        <Col xs={24} sm={12} md={4}>
                          <Select
                            placeholder="Departamento"
                            style={{ width: "100%" }}
                            showSearch
                            optionFilterProp="children" // busca dentro del texto de las opciones
                            value={departamentoSeleccionado}
                            onChange={(value) => {
                              setDepartamentoSeleccionado(value);
                              setMunicipioSeleccionado(null);
                            }}
                            disabled={!listDepartamento?.length}
                            allowClear
                          >
                            {listDepartamento.map((dep) => (
                              <Option key={dep} value={dep}>
                                {dep}
                              </Option>
                            ))}
                          </Select>
                        </Col>

                        {/* Municipio */}

                        <Col xs={24} sm={12} md={4}>
                          <Select
                            placeholder="Municipio"
                            style={{ width: "100%" }}
                            showSearch
                            optionFilterProp="children" // busca dentro del texto de las opciones
                            value={municipioSeleccionado || undefined}
                            onChange={(value) =>
                              setMunicipioSeleccionado(value)
                            }
                            disabled={!listMunicipio?.length}
                            allowClear
                          >
                            {listMunicipio?.map((mun) => (
                              <Option key={mun} value={mun}>
                                {mun}
                              </Option>
                            ))}
                          </Select>
                        </Col>

                        {/* Organización */}
                        <Col xs={24} sm={12} md={4}>
                          <Select
                            placeholder="Proyecto"
                            style={{ width: "100%" }}
                            showSearch
                            optionFilterProp="children" // busca dentro del texto de las opciones
                            value={proyectoSeleccionado || undefined}
                            onChange={(value) => setProyectoSeleccionado(value)}
                            disabled={!listProyectos?.length}
                            allowClear
                          >
                            {listProyectos?.map((p) => (
                              <Option key={p} value={p}>
                                {p}
                              </Option>
                            ))}
                          </Select>
                        </Col>

                        {/* Barra de búsqueda */}
                        <Col xs={24} sm={12} md={5} lg={5}>
                          <Input
                            placeholder="Buscar..."
                            prefix={<SearchOutlined />}
                            value={searchText}
                            onChange={(value) => setSearchText(value)}
                          />
                        </Col>

                        {/* Botón Limpiar */}
                        <Col xs={12} sm={6} md={2} lg={2}>
                          <Button
                            type="primary"
                            icon={<ClearOutlined />}
                            style={{ width: "100%" }}
                            onClick={handleClearFilters}
                          >
                            Limpiar
                          </Button>
                        </Col>
                        {/*  <Col xs={12} sm={6} md={2} lg={2}>
                          {permissionInsert && (
                            <Button
                              type="primary"
                              style={{
                                width: "100%",
                                backgroundColor: "#52c41a",
                                borderColor: "#52c41a",
                              }}
                              icon={<PlusOutlined />}
                              onClick={() => {
                                setModalKey((prevKey) => prevKey + 1); // Cambia la clave para forzar el re-render
                                setModalVisible(true);
                              }}
                            >
                              Nuevo
                            </Button>
                          )}
                        </Col> */}

                        {/* Total */}
                        <Col xs={12} sm={6} md={3} lg={3}>
                          <Card
                            size="small"
                            style={{
                              marginTop: "24px",
                              textAlign: "center",
                              backgroundColor: "#f0f5ff", // Fondo azul claro
                            }}
                          >
                            <Statistic
                              title="Total participantes"
                              value={filterParticipantes.length}
                              valueStyle={{
                                color: "#1890ff",
                                fontWeight: "bold",
                              }}
                            />
                          </Card>
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>

                <div className="row mb-4">
                  <div className="col-12">
                    {filterParticipantes.length > 0 ? (
                      <Table
                        columns={columns}
                        dataSource={filterParticipantes}
                        rowKey="id"
                        bordered
                        scroll={{ y: 500, x: "max-content" }}
                        pagination={{
                          current: currentPage, // 👈 página actual
                          pageSize: pageSize, // 👈 filas por página
                          total: filterParticipantes.length, // 👈 total de registros
                          showSizeChanger: true,
                          pageSizeOptions: ["10", "20", "50", "100"],
                          showTotal: (total, range) =>
                            `${range[0]}-${range[1]} de ${total} participantes`,
                          onChange: (page, size) => {
                            setCurrentPage(page);
                            setPageSize(size); // 👈 también actualiza cuando cambia el tamaño
                          },
                        }}
                      />
                    ) : (
                      <div style={{ textAlign: "center", margin: "20px" }}>
                        <Alert
                          message="No hay resultados"
                          description="No se encontraron participantes"
                          type="info"
                          showIcon
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <Modal
                open={modalVisible}
                onCancel={handleCancel}
                key={"id"}
                width={1200}
                title="Nuevo  Participante" // Título del Modal
                style={{
                  top: 20, // Puedes ajustar la posición del modal si es necesario
                  borderRadius: "8px", // Estiliza el borde del modal
                  textAlign: "center",
                }}
                footer={null} // Esto elimina el pie de página predeterminado, si no lo necesitas
              >
                <div className="modal-container">
                  <ParticipanteForm
                    key={modalKey}
                    onClose={() => setModalVisible(false)}
                    form={formParticipante}
                    fetchData={fetchparticipantes}
                    initialData={selectParticipante}
                  />
                </div>
              </Modal>
            </div>
          </>
        )}
      </>
    </>
  );
};

export default ParticipantesSostenibilidad;
